<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My teacher said there’s a book and I have the title</h1>
			<div>
				<h3>Please enter book title:</h3>
				<v-text-field label="Book Title & Author" v-model="book_title" :rules="title_rules" solo flat></v-text-field>
			</div>
			<div>
				<h3>Email:</h3>

				<email-form
						subject="My teacher said there’s a book and I have the title"
						:body="email_body"
						on-success-url="/help?#/submitted"
						edit-body
						destination-key="ge"
				></email-form>
			</div>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';

	export default {
		name: "ThereIsBookGotTitle",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				book_title: '',
				course_id: '',
				title_rules: [v => v.length > 3 || 'Too short']
			}
		},

		computed: {
			email_body() {
				return `Hello, My professor said there is a book for course ${this.course_id} and the title is: ${this.book_title}.\nCan you have someone talk to my professor so I can buy my book?`
			},
		},

		mounted() {
			this.course_id = parseInt(this.$route.params['course_id']);
		}
	}
</script>

<style scoped>

</style>